<template>
  <div class="tabs-view">
    <el-tabs
        v-model="activeTab"
        type="card"
        closable
        @tab-click="handleTabClick"
        @tab-remove="handleTabRemove"
    >
      <el-tab-pane
          v-for="item in visitedViews"
          :key="item.path"
          :label="item.title"
          :name="item.path"
          :closable="item.path !== '/personalHomepage'"
      >
      </el-tab-pane>
    </el-tabs>
    <div class="tabs-content">
      <keep-alive :include="cachedViews">
        <router-view />
      </keep-alive>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabsView',
  data() {
    return {
      activeTab: '',
      visitedViews: [],
      cachedViews: []
    }
  },
  watch: {
    '$route.path': {
      handler(newPath, oldPath) {
        if (newPath !== oldPath) {
          this.addViewToTabs(this.$route)
        }
        this.activeTab = newPath
      },
      immediate: true
    },
    permissionMenuList: {
      handler() {
        this.updateAllTabsTitle()
      },
      deep: true
    }
  },
  computed: {
    permissionMenuList() {
      return this.$store.state.permissionMenuList || []
    },
    menuPathMap() {
      const map = new Map()
      const buildMap = (list) => {
        if (!list) return
        for (const menu of list) {
          if (menu.pageUrl) map.set(menu.pageUrl, menu.permissionName)
          if (menu.childrenList) buildMap(menu.childrenList)
        }
      }
      buildMap(this.permissionMenuList)
      return map
    },
    findMenuName() {
      return (path) => {
        return this.menuPathMap.get(path) || path.split('/').pop() || '首页'
      }
    }
  },
  mounted() {
    if (this.$route.path) {
      this.addViewToTabs(this.$route)
      this.activeTab = this.$route.path
    }
  },
  methods: {
    // 安全跳转方法，避免重复导航报�?
    safePush(path) {
      if (path === this.$route.path) return
      this.$router.push(path).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error(err)
        }
      })
    },

    addViewToTabs(route) {
      const title = this.findMenuName(route.path)
      const view = {
        path: route.path,
        title: title,
        name: route.name,
        query: route.query
      }

      const exists = this.visitedViews.some(v => v.path === view.path)
      if (!exists) {
        this.visitedViews.push(view)
      }

      if (route.name && !this.cachedViews.includes(route.name)) {
        this.cachedViews.push(route.name)
      }
    },

    updateAllTabsTitle() {
      this.visitedViews = this.visitedViews.map(view => {
        const newTitle = this.findMenuName(view.path)
        return { ...view, title: newTitle }
      })
    },

    handleTabClick(tab) {
      this.safePush(tab.name)
    },

    handleTabRemove(path) {
      const view = this.visitedViews.find(v => v.path === path)
      const index = this.visitedViews.findIndex(v => v.path === path)
      if (index !== -1) {
        this.visitedViews.splice(index, 1)
      }

      if (view && view.name) {
        const cacheIndex = this.cachedViews.indexOf(view.name)
        if (cacheIndex !== -1) {
          this.cachedViews.splice(cacheIndex, 1)
        }
      }

      if (this.activeTab === path) {
        const lastView = this.visitedViews[this.visitedViews.length - 1]
        if (lastView) {
          this.safePush(lastView.path)
        } else {
          this.safePush('/personalHomepage')
        }
      }
    }
  }
}
</script>

<style scoped>
.tabs-view {
  display: block;  /* 改为 block，让内容自然堆叠 */
  background: #f3f4f6;

}

.tabs-view ::v-deep .el-tabs {
  background: #fff;
  border-bottom: 1px solid #e4e7ed;
  flex-shrink: 0;
}

.tabs-view ::v-deep .el-tabs__header {
  margin: 0;
}

.tabs-view ::v-deep .el-tabs__nav {
  border: none;
}

.tabs-view ::v-deep .el-tabs__item {
  height: 40px;
  line-height: 40px;
  font-size: 13px;
}

.tabs-view ::v-deep .el-tabs__item.is-closable:hover {
  background-color: #f5f7fa;
}

.tabs-view ::v-deep .el-tabs__item.is-active {
  color: #409eff;
  border-bottom: 2px solid #409eff;
}

.tabs-content {
  padding: 16px;

}
</style>